import { render, staticRenderFns } from "./BarGraphWidget.vue?vue&type=template&id=063f8d92&"
import script from "./BarGraphWidget.vue?vue&type=script&lang=js&"
export * from "./BarGraphWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063f8d92')) {
      api.createRecord('063f8d92', component.options)
    } else {
      api.reload('063f8d92', component.options)
    }
    module.hot.accept("./BarGraphWidget.vue?vue&type=template&id=063f8d92&", function () {
      api.rerender('063f8d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/TouchpointInfo/BarGraphWidget.vue"
export default component.exports